import { Benefit, State } from '@witkac/kartamiejska-shared';
import { BenefitResource, benefitResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';
import { LocalStorage } from '@/enums/storage.enum';
import { tryParseInt } from '@witkac/utils/tryParseInt';

/**
 * Moduł partnerów
 *
 * @export
 * @class BenefitModule
 * @extends {EntityModule<Benefit, BenefitResource>}
 */
export class BenefitModule extends EntityModule<Benefit, BenefitResource> {
  constructor() {
    super(benefitResource);
    this.actions = {
      ...this.actions,
      /**
       * Listowanie benefitów z domyślnym filtrowaniem
       *
       * @param {*} context
       * @param {*} filters
       * @returns {Promise<void>}
       */
      list: async (context: any, filters: any): Promise<void> => {
        const { list, count } = await this.resource.list({
          upToDate: true,
          state: State[State.ACTIVE],
          ...filters,
          profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID)) as number
        });
        context.commit('saveList', list);
        context.commit('saveCount', count);
      },

      /**
       * Pobiera Benefit
       *
       * @param context context
       * @param id identyfikator encji
       */
      get: async (context: any, id?: number | string): Promise<Benefit> => {
        const entity = await this.resource.getWithProfileId({
          id: id || context.state.id,
          profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID)) as number
        });
        context.commit('setEntity', entity);
        return entity;
      }
    };
  }
}

export default new BenefitModule();
